import moment from 'moment'
import _ from 'lodash'
import { Row, Col } from 'antd'
import styles from './CustomizedTooltip.css'
import { numeralFormat, dollarFormat } from '../../../../../../../../lib/renderUtil'
import {
  ChartToolTip,
  Title,
  Item,
  ItemIcon
} from '../../../../../../Common/NewDashboard/Chart/ToolTip'
import {
  TOOLTIP_DETAIL,
  TOOLTIP_DETAIL_LIST,
  TOOLTIP_DETAIL_MAP,
  SELLER_TOOLTIP_DETAIL,
  SELLER_TOOLTIP_DETAIL_LIST,
  SELLER_TOOLTIP_DETAIL_WITH_ONE_CARRIER_LIST,
  SELLER_TOOLTIP_DETAIL_MAP,
  getGroupByReportDateTypePayload
} from '../ViewsChart'

const WAITING_DETAIL_TEXT = '計算中'

const CustomizedTooltip = props => {
  const {
    active,
    payload = [],
    format,
    timeDuration,
    isDetailVisible,
    isDailyDetailLoaded,
    saleStateMapByTimeDuration,
    isSeller,
    isOneCarrierSelected,
    isAllCarrierSelected
  } = props
  const {
    mainRange: mainPayload = [],
    comparisonRange: comparisonPayload = []
  } = getGroupByReportDateTypePayload(payload, 'name')
  const transformedPayloadList = _.filter([mainPayload, comparisonPayload], payload => !_.isEmpty(payload))
  const sellerTooltipDetailKeys = (() => {
    const base = isOneCarrierSelected
      ? SELLER_TOOLTIP_DETAIL_WITH_ONE_CARRIER_LIST
      : SELLER_TOOLTIP_DETAIL_LIST
    if (!isAllCarrierSelected) {
      return _.without(base, SELLER_TOOLTIP_DETAIL.UNIQUE_CART_QUANTITY)
    }
    return base
  })()

  if (active) {
    return (
      <ChartToolTip>
        <Row gutter={12}>
          {transformedPayloadList.map((transformedPayload, blockIndex) => {
            const reportDate = _.get(transformedPayload, '0.payload.correctReportDate')
            const pageView = _.get(transformedPayload, '0.payload.pageView', 0)
            const formatedReportDate = moment(reportDate).format(format)
            // 主要區間與比較區間佔 tooltip 內的比例
            const blockSize = 24 / _.size(transformedPayloadList)
            return (
              <Col
                span={blockSize}
                key={blockIndex}
              >
                <Title>
                  {formatedReportDate}
                </Title>
                {transformedPayload.map((item, itemIndex) => {
                  const { stroke, name, value } = item
                  return (
                    <Item
                      key={itemIndex}
                      className={styles.item}
                    >
                      <ItemIcon color={stroke} />
                      {`${name}：${numeralFormat(value, { allowZero: true })}`}
                    </Item>
                  )
                })}
                {isDetailVisible && _.map(
                  isSeller ? sellerTooltipDetailKeys : TOOLTIP_DETAIL_LIST,
                  key => {
                    if (!isDailyDetailLoaded) {
                      return (
                        <Item key={key}>
                          {`${isSeller ? SELLER_TOOLTIP_DETAIL_MAP[key] : TOOLTIP_DETAIL_MAP[key]}：${WAITING_DETAIL_TEXT}`}
                        </Item>
                      )
                    }

                    const detailValue = _.toNumber(
                      // 圖表目前使用的時間區間-日期-銷售概況欄位
                      _.get(saleStateMapByTimeDuration, `${timeDuration}.${reportDate}.${key}`, 0)
                    )
                    const dollorKeyList = isSeller
                      ? [SELLER_TOOLTIP_DETAIL.ORDER_AMOUNT, SELLER_TOOLTIP_DETAIL.REFUND_AMOUNT]
                      : [TOOLTIP_DETAIL.ORDER_AMOUNT, TOOLTIP_DETAIL.REFUND_AMOUNT]
                    const formattedValue = _.includes(dollorKeyList, key)
                      ? dollarFormat(detailValue)
                      : numeralFormat(detailValue, { allowZero: true })

                    if (isSeller && key === SELLER_TOOLTIP_DETAIL.CONVERSION_RATE) {
                      const conversionRate = _.toNumber(
                        _.get(saleStateMapByTimeDuration, `${timeDuration}.${reportDate}.${SELLER_TOOLTIP_DETAIL.SOLD_QUANTITY}`, 0)
                      ) / pageView
                      return (
                        <Item key={key}>
                          {`${SELLER_TOOLTIP_DETAIL_MAP[key]}：${_.floor(conversionRate * 100, 2)}`}
                          %
                        </Item>
                      )
                    }

                    return (
                      <Item key={key}>
                        {`${isSeller
                          ? SELLER_TOOLTIP_DETAIL_MAP[key]
                          : TOOLTIP_DETAIL_MAP[key]
                        }：${formattedValue}`}
                      </Item>
                    )
                  }
                )}
              </Col>
            )
          })}
        </Row>
      </ChartToolTip>
    )
  }
  return null
}

export default CustomizedTooltip
